import React from "react";

import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import { SubtleBadge } from "components/Badge";
import { SlimSecondaryButton } from "components/Button";
import { CollapseLabel, FormCollapse } from "components/Form";
import { Row } from "components/Layout";

import { ModalTypes } from "constants/navigation";

import { openModalLink } from "lib/navigation";

import {
  getDescriptionByVendorSplitId,
  getVendorIdByConsignmentId,
  selectDeploymentIdByConsignmentIdLookup,
} from "selectors";

import { useGetBestMatchingVendorSplit } from "hooks/useGetBestMatchingVendorSplit";

function VendorSplitHeader({ splitDescription }: { splitDescription: string }) {
  return (
    <Row>
      <SubtleBadge>Vendor Splits</SubtleBadge>
      <CollapseLabel>{splitDescription}</CollapseLabel>
    </Row>
  );
}

interface VendorSplitSectionProps {
  isOpen: boolean;
  onToggle: () => void;
  consignmentId: string;
}

export const VendorSplitSection = ({
  isOpen,
  onToggle,
  consignmentId,
}: VendorSplitSectionProps) => {
  const primaryVendorId = useSelector(
    getVendorIdByConsignmentId(consignmentId),
  );

  const primaryBusinessId = useSelector(
    getVendorIdByConsignmentId(consignmentId),
  );

  const deploymentId = useSelector(selectDeploymentIdByConsignmentIdLookup)[
    consignmentId
  ];

  const split = useGetBestMatchingVendorSplit({
    deploymentId,
    primaryBusinessId,
    consignmentId,
  });
  const splitDescription = useSelector(
    getDescriptionByVendorSplitId(split?.id),
  ) as [];

  const onClickCreateVendorSplit = () =>
    openModalLink(ModalTypes.VendorSplit, {
      deploymentId,
      primaryBusinessId: primaryVendorId,
      consignmentId,
    });

  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={
        <VendorSplitHeader splitDescription={splitDescription.join(", ")} />
      }
      dataTour={isOpen ? "hideVendorSplits" : "showVendorSplits"}
    >
      <Grid item xs={12} container justifyContent="center">
        <SlimSecondaryButton
          type="button"
          onClick={onClickCreateVendorSplit}
          data-tour="createVendorSplit"
        >
          {split ? "Edit" : "Create"} Vendor Split
        </SlimSecondaryButton>
      </Grid>
    </FormCollapse>
  );
};
